import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, CDN_URL, formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import SubscriptionExpiredWidget from '../ones/SubscriptionExpiredWidget';
import { RxHeart, RxHeartFilled } from "react-icons/rx";
import { FaRegCommentDots } from "react-icons/fa6";
import { STR_COMMENTS, STR_INVALID_COMMENT, STR_NO_COMMENTS, STR_NO_DATA_FOUND, STR_SUBMIT, STR_WRITE_YOUR_COMMENT } from "../Strings";
import OneComment from '../ones/OneComment';


export default function View({ id, type }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [comments, setComments] = useState(null);
	const [commentBody, setCommentBody] = useState("");
	const [loading, setLoading] = useState(false);

	async function sendComment() {
		if(commentBody.trim().length > 0) {
			setLoading(true);
			await callApi(
				`send-${type}-comment`, 
				{
					body: commentBody,
					articleId: id,
					confessionId: id,
				}
			).then(response => {
				if(response.status === 1) {
					getComments();
					setCommentBody("");
				} else {
					appContext.tellError(response.msg);
				}
			})
			setLoading(false);
		} else {
			appContext.tellError(STR_INVALID_COMMENT[appContext.language]);
		}
	}


	async function init() {
		//run initializations here
		setReady(false);
		await getComments();
		setReady(true);
	}

	async function getComments() {
		await callApi(`get-${type}-comments`, { id }).then(response => {
			if (response.status === 1) {
				setComments(response.data);
			}
		})
	}

	useEffect(() => {
		if(comments) {
			
		}
	}, [comments])

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if (ready) {
		return (
			<div className="container">
				<div className="row">

					<div className="col-md-12">
						<h6
							className="font-semi-bold"
							style={{
								fontSize: "16px",
								textTransform: "uppercase",
							}}
						>
							{STR_COMMENTS[appContext.language]}
						</h6>
					</div>

					<div className="col-md-12">
						<div className="card bg-background">
							<div className="card-body">
								<div className="mb-2 mt-2">
									<textarea
										value={commentBody}
										onChange={(e) => setCommentBody(e.target.value)}
										className="form-control"
										placeholder={STR_WRITE_YOUR_COMMENT[appContext.language]}
									/>

									<div className="text-end mt-2">
										<button
											className="btn btn-sm btn-rounded btn-primary"
											onClick={sendComment}
										>
											{STR_SUBMIT[appContext.language]}
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="col-md-12">
						{
							(comments && comments.length > 0) ?
							comments.map((item, i) => {
								return (
									<OneComment key={i} data={item}/>
								)
							})
							:
							<h6
								style={{
									fontSize: "14px"
								}}
							>
								{STR_NO_COMMENTS[appContext.language]}
							</h6>
						}
					</div>

				</div>
			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading container"
			>
				{getInlineLoader()}
			</div>
		);
	}


}